import { Feature, Point } from "geojson";
import { Marker, Popup } from "maplibre-gl";
import { LayerParams } from "src/app/instant-analysis/map/layer-manager";
import { EventGroups } from "src/app/instant-analysis/models/event-groups";
import { MathAux } from "src/app/instant-analysis/services/math-aux/math-aux";
import { MarkerBuilder } from "../marker-builder";

export class EventMarkerBuilder implements MarkerBuilder {

  /** Cores das ocorrências:
   * deslizamento: marrom
   * alagamento: roxo
   * desmoronamento: cinza
   */
  eventColors: { [key: string]: string } = {
    'DESLIZAMENTO': '#664422',
    'ALAGAMENTO': '#6600EE',
    'DESABAMENTO': '#505050',
  };

  constructor(public onClicked: Function) {}

  createMarker(feature: Feature<Point, { [name: string]: any; }>, layerParams: LayerParams): Marker {
    
    let { index } = feature.properties;

    let group = EventGroups.getGroup(feature.properties.motivo);
    let customMarker = this.createCustomMarker(feature, index, group);

    let [long, lat] = feature.geometry.coordinates;
    let mark = new Marker({element: customMarker}).setLngLat([long, lat]);
    return mark;
  }

  createPopupContent(feature: Feature<Point, { [name: string]: any; }>, layerParams: LayerParams): Popup {
    
    const { LPAD } = MathAux;
    let formatedmin = LPAD(feature.properties.minuto);
    let formatedhour = LPAD(feature.properties.hora);
    let formatedday = LPAD(feature.properties.dia);
    let formatedmonth = LPAD(feature.properties.mes);

    let group = EventGroups.getGroup(feature.properties.motivo);

    let html = `
      <h3 style="margin-bottom: 0 !important; text-align: center;font-weight: bold;">
        ${group}
      </h3>
      <div style="text-align: center; font-size: 0.85em !important">
        ${feature.properties.motivo}
      </div>
      <div style="text-align: center;">
        ID da solicitação: ${feature.properties.id_solicitacao}
      </div>
      <!-- <div style="text-align: center;">
        Bairro: ${feature.properties.bairro}
      </div> -->
      <div style="text-align: center;">
        ${formatedday}/${formatedmonth}/${feature.properties.ano} às ${formatedhour}:${formatedmin}
      </div>`

    let popup = new Popup({offset: 25}).setHTML(html);

    return popup;
  }

  private createCustomMarker(feature: Feature, index: number, group: string) {

    var el = document.createElement('div');
    el.innerHTML = `<svg version="1.1" id="Camada_${index}" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px"
    viewBox="0 0 24 24" style="enable-background:new 0 0 24 24;" xml:space="preserve">
    <style type="text/css">
    .st0-${index}{fill:none;}
    .st1-${index}{fill:${this.eventColors[group]};stroke:#7A7A7A;stroke-width:5.000000e-02;stroke-miterlimit:10;}
    .st2-${index}{fill:#FFFFFF;stroke:#7A7A7A;stroke-width:5.000000e-02;stroke-miterlimit:10;}
    </style>
    <path class="st0-${index}" d="M0,0h24v24H0V0z"/>
    <path class="st1-${index}" d="M12,2c-4.4,0-8,3.6-8,8c0,0.1,0,0.1,0,0.2c0,3.3,2.7,7.3,8,11.8c5.3-4.6,8-8.5,8-11.8c0.1-4.4-3.4-8.1-7.8-8.2
      C12.1,2,12.1,2,12,2z"/>
    <rect x="11" y="6" class="st2-${index}" width="2" height="5"/>
    <rect x="11" y="13" class="st2-${index}" width="2" height="2"/>
    </svg>`
    el.className = "marker";

    return el;
  }

}
